/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HideItemClientFeedbackMutationVariables = Types.Exact<{
  input: Types.HideItemClientFeedbackUpdateInput;
}>;
export type HideItemClientFeedbackMutation = {
  __typename?: "Mutation";
  hideItemClientFeedbackUpdate?: {
    __typename?: "HideItemClientFeedbackUpdatePayload";
    result: {
      __typename?: "KeptItemHideResult";
      clientItemActionId: string;
      clientItemAction: {
        __typename?: "ClientItemAction";
        hiddenAt?: string | null;
      };
    };
  } | null;
};
export const HideItemClientFeedbackDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "hideItemClientFeedback"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "HideItemClientFeedbackUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "hideItemClientFeedbackUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "clientItemActionId"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "clientItemAction"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "hiddenAt"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type HideItemClientFeedbackMutationFn = Apollo.MutationFunction<HideItemClientFeedbackMutation, HideItemClientFeedbackMutationVariables>;

/**
 * __useHideItemClientFeedbackMutation__
 *
 * To run a mutation, you first call `useHideItemClientFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideItemClientFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideItemClientFeedbackMutation, { data, loading, error }] = useHideItemClientFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHideItemClientFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<HideItemClientFeedbackMutation, HideItemClientFeedbackMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<HideItemClientFeedbackMutation, HideItemClientFeedbackMutationVariables>(HideItemClientFeedbackDocument, options);
}
export type HideItemClientFeedbackMutationHookResult = ReturnType<typeof useHideItemClientFeedbackMutation>;
export type HideItemClientFeedbackMutationResult = Apollo.MutationResult<HideItemClientFeedbackMutation>;
export type HideItemClientFeedbackMutationOptions = Apollo.BaseMutationOptions<HideItemClientFeedbackMutation, HideItemClientFeedbackMutationVariables>;